<template>
   <RouterLink class="nav" to="/admin"><DButton color="primary" label="Admin console" style="margin: 16px;"/></RouterLink>
  <DashboardController :isPreview="false" />
</template>
<script>
import DashboardController from '@components/DashboardController.vue'
import DButton from '@components/ui/DButton.vue'
export default {
  components: {
    DashboardController,
    DButton
  }
}
</script>
<style scoped>
/* .root {
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  justify-content: center;
  align-items: center;
} */

.title {
  margin-bottom: 50px;
}

.nav {
  position: absolute;
  top: 0px;
  right: 0px;
  opacity: 0;
  z-index: 99;
}
.nav:hover{
  opacity: 1;
}
.btn-blue {
  background-color: #0077B6;
  color: white;
  border: none;
  padding: 8px 16px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 12px;
  margin: 4px 2px;
  cursor: pointer;
}
</style>
